<template>
  <div class="flex-col page">
    <div class="flex-col self-stretch group">
    </div>
    <div class="flex-row self-center group_5">
      <div class="flex-col justify-start shrink-0 relative group_6">
        <div class="flex-col section_3">
          <div class="flex-col group_9">
            <div v-for="(item, index) in itemTypes"
              class="row flex-row items-center"
              :class="{active: selected === item.id}"
              :key="index"
              @click="changeItemType(item)"
              >
              <el-icon :class="`icon ${item.icon}`" />
              <span class="ml-12 font_3">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="section_5 pos"></div>
      </div>
      <div class="flex-col flex-1 self-start group_7 ml-83">
        <div v-if="selected === '1'" class="info-box">
          <p class="tilte">账号信息</p>
          <p v-for="(item, index) in userInfo" class="row" :key="index">
            <span class="key">{{item.key}}</span>
            <span class="value">{{item.value}}</span>
          </p>
        </div>
        <div v-if="selected === '2'" class="info-box">
          <p class="tilte">密码修改</p>
          <p v-for="(item, index) in passwordData" class="row" :key="index">
            <span class="key">{{item.key}}</span>
            <span class="value">
              <el-input class="input" type="password" :placeholder="item.placeholder" v-model="item.value" />
            </span>
          </p>
          <el-button class="btn" type="primary" @click="submitPassword">确认修改</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      selected: '1',
      itemTypes: [
        { id: '1', name: '账号信息', icon: 'el-icon-document' },
        { id: '2', name: '修改密码', icon: 'el-icon-lock' },
        { id: '3', name: '退出登录', icon: 'el-icon-switch-button' }
      ],
      userInfo: [
        { key: '账号名', value: this.$store.state.username }
      ],
      passwordData: [
        { prop: 'old', key: '原密码', value: '', placeholder: '请输入原密码' },
        { prop: 'password', key: '新密码', value: '', placeholder: '请输入新密码' },
        { prop: 'repassword', key: '新密码确认', value: '', placeholder: '请再次输入新密码' }
      ]
    }
  },
  watch: {
    '$store.state.username': {
      handler (vl) {
        this.userInfo = [{ key: '账号名', value: vl }]
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    async changeItemType (item) {
      const { id } = item

      // 退出登录
      if (id === '3') {
        const res = await this.$https.logout()
        if (res.data.status) {
          this.$message.success(res.data.msg)
          setTimeout(() => {
            window.location.href = '/#/login'
          }, 500)
        }
        return
      }

      this.selected = id
    },
    async submitPassword () {
      const config = {}
      this.passwordData.forEach(v => {
        config[v.prop] = v.value
      })
      const res = await this.$https.profile(config)
      if (res.data.status) {
        this.$message.success('修改成功')
        setTimeout(() => {
          window.location.href = '/#/login'
        }, 500)
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.info-box{
  display: flex;
  flex-direction: column;

  .title{
    font-size: 16px;
    color: #333;
  }

  .row{
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #666;

    .key{
      width: 160px;
    }
  }

  /deep/ .el-input.is-active .el-input__inner,
  /deep/ .el-input__inner:focus{
    border-color: #0067d1;
  }

  .btn{
    padding: 8px 0;
    background-color: #0071d6;
    border-radius: 2px;
    width: 94px;
    height: 32px;
    margin-left: 160px;
    margin-top: 30px;
    cursor: pointer;
  }
}
  .ml-5 {
    margin-left: 5px;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .mt-107 {
    margin-top: 107px;
  }
  .mt-35 {
    margin-top: 35px;
  }
  .ml-11 {
    margin-left: 11px;
  }
  .ml-83 {
    margin-left: 83px;
  }
  .mt-21 {
    margin-top: 21px;
  }
  .ml-27 {
    margin-left: 27px;
  }
  .ml-17 {
    margin-left: 17px;
  }
  .mt-27 {
    margin-top: 27px;
  }
  .ml-187 {
    margin-left: 187px;
  }
  .ml-3 {
    margin-left: 3px;
  }
  .page {
    background-color: #ffffff;
    width: 1920px;
    height: 100%;
    .group {
      padding-bottom: 37px;
      .section {
        padding: 53px 0 46px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 39px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 29px;
        }
        .text_3 {
          color: #004290;
          font-size: 32px;
          font-family: Alibaba;
          line-height: 34px;
        }
      }
      .section_2 {
        padding: 16px 362px 16px 388px;
        background-color: #006ed1;
        .group_2 {
          margin-left: 85px;
        }
        .group_3 {
          margin-left: 80px;
        }
        .image_2 {
          width: 13px;
          height: 8px;
        }
        .group_4 {
          margin-left: 81px;
        }
        .image {
          width: 28px;
          height: 32px;
        }
        .text_4 {
          color: #ffffff;
        }
      }
    }
    .group_5 {
      width: 1440px;
      border-top: solid 3px #0067d1;
      .group_6 {
        width: 201px;
        .section_3 {
          padding-top: 53px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          min-height: 600px;
          background-color: #f9f9f9;
          .image_3 {
            width: 115px;
            height: 116px;
          }
          .font_3 {
            font-size: 14px;
            font-family: PingFang;
            line-height: 14px;
            color: #666666;
          }
          .group_9 {
            .row{
              height: 38px;
              line-height: 38px;
              margin-bottom: 20px;
              cursor: pointer;
              padding-left: 37px;
              border-left: 5px solid #f9f9f9;;
              opacity: 1;

              &:hover{
                opacity: .5;
              }

              &.active{
                opacity: 1;
                border-left: 5px solid #0067d1;

                .icon{
                  color: #0067d1;
                }

                .font_3{
                  color: #0067d1;
                }
              }

              .icon{
                color: #666;
              }
            }
            .image_5 {
              width: 18px;
              height: 20px;
            }
            .image_6 {
              width: 20px;
              height: 22px;
            }
            .text_9 {
              color: #006ed1;
            }
            .image_7 {
              width: 18px;
              height: 21px;
            }
            .text_10 {
              line-height: 13px;
            }
            .text_11 {
              line-height: 13px;
            }
            .image_8 {
              width: 18px;
              height: 19px;
            }
          }
        }
        .section_5 {
          // background-color: #006ed1;
          height: 38px;
        }
        .pos {
          position: absolute;
          left: 0;
          right: 196px;
          top: 294px;
        }
      }
      .group_7 {
        margin-top: 59px;
        .text_5 {
          margin-left: 3px;
        }
        .group_8 {
          margin-top: 19px;
          padding: 43px 7px 49px;
          border-top: solid 1px #999999;
          .text-wrapper {
            padding: 15px 0;
            background-color: #006ed1;
            width: 164px;
            height: 47px;
            .text_6 {
              line-height: 17px;
            }
          }
          .text_7 {
            margin-top: 30px;
            color: #999999;
            line-height: 15px;
          }
        }
        .section_4 {
          margin-left: 7px;
          padding: 18px 56px;
          background-color: #e0edf9;
          width: 317px;
          .image_4 {
            width: 40px;
            height: 36px;
          }
          .text_8 {
            margin-right: 14px;
            color: #006ed1;
            font-size: 18px;
            font-family: PingFang;
            line-height: 17px;
          }
        }
      }
    }
    .font_2 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 16px;
      color: #333333;
    }
    .font {
      font-size: 18px;
      font-family: PingFang;
      line-height: 18px;
      color: #ffffff;
    }
    .group_10 {
      margin-top: 144px;
      .section_6 {
        padding: 46px 246px 41px;
        background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=fea1547a76297dd513dc427961a20b74.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .section_7 {
          padding: 10px 22px;
          background-color: #006ed1;
          .image_9 {
            width: 26px;
            height: 26px;
          }
          .text_12 {
            margin-right: 13px;
          }
        }
        .group_11 {
          padding: 27px 6px;
          .text-wrapper_2 {
            flex: 1 1 333px;
            padding: 28px 0;
            background-color: #e0edf9;
            height: 74px;
            border-left: solid 1px #006ed1;
            border-right: solid 1px #006ed1;
            border-top: solid 1px #006ed1;
            border-bottom: solid 1px #006ed1;
          }
          .text-wrapper_3 {
            flex: 1 1 333px;
            padding: 28px 0;
            background-color: #e0edf9;
            height: 75px;
            border-left: solid 1px #006ed1;
            border-right: solid 1px #006ed1;
            border-top: solid 1px #006ed1;
            border-bottom: solid 1px #006ed1;
          }
        }
      }
      .section_8 {
        padding: 8px 0 37px;
        background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=75fa7447de05642c51ee4489989b7d55.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .group_12 {
          padding: 106px 360px 30px;
          height: 188px;
          .image_11 {
            width: 40px;
            height: 43px;
          }
          .pos_3 {
            position: absolute;
            left: 362px;
            bottom: 38px;
          }
          .image_13 {
            width: 48px;
            height: 36px;
          }
          .pos_7 {
            position: absolute;
            left: 673px;
            bottom: 39px;
          }
          .font_5 {
            font-size: 16px;
            font-family: PingFang;
            line-height: 16px;
            color: #b2b3b8;
          }
          .pos_4 {
            position: absolute;
            left: 734px;
            bottom: 66px;
          }
          .text_15 {
            color: #006ed1;
            font-size: 24px;
            font-family: PingFang;
            font-weight: 700;
            line-height: 20px;
          }
          .pos_8 {
            position: absolute;
            left: 418px;
            bottom: 34px;
          }
          .font_4 {
            font-size: 24px;
            font-family: PingFang;
            line-height: 23px;
          }
          .text_16 {
            color: #006ed1;
          }
          .pos_9 {
            position: absolute;
            left: 735px;
            bottom: 30px;
          }
          .image_12 {
            width: 31px;
            height: 43px;
          }
          .pos_6 {
            position: absolute;
            right: 877px;
            bottom: 37px;
          }
          .pos_5 {
            position: absolute;
            right: 834px;
            bottom: 66px;
          }
          .group_13 {
            width: 1326px;
            .group_14 {
              margin-top: 39px;
              .image_10 {
                width: 41px;
                height: 41px;
              }
              .text_13 {
                color: #b2b3b8;
              }
              .text_14 {
                line-height: 15px;
              }
            }
            .text_17 {
              margin-top: 135px;
              color: #006ed1;
              font-size: 20px;
              font-family: PingFang;
              line-height: 20px;
            }
            .section_9 {
              background-color: #2e3142;
              width: 204px;
              height: 188px;
            }
          }
          .pos_2 {
            position: absolute;
            right: 234px;
            top: 0;
          }
        }
        .group_15 {
          padding: 0 360px;
          .group_16 {
            width: 466px;
          }
          .font_6 {
            font-size: 14px;
            font-family: PingFang;
            line-height: 11px;
            color: #939598;
          }
        }
      }
    }
    .text {
      text-transform: uppercase;
    }
  }
</style>
